
// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";


const http = new AxiosAdapter();





export const getMainService = async() => {

    try {

        return await http.get<any>(`/v1/main/get-data-main`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getMainService ',error)
    }
}


